import React, { useEffect, useRef } from 'react';
import { Icon, Tooltip } from '@sm/ide-components';
import type { QuickQuestion } from '@/types/chat';
import { emitGa } from '@/utils/ga';
import { getMacawRoot } from '@/utils/macawRoot';
import './index.less';

interface QuickQuestionsProps {
  questions: QuickQuestion[];
  onSelect: (question: string) => void;
  disabled?: boolean;
  /** 抽屉是否正打开。关掉后清除去重，下次打开再报一次 */
  visible?: boolean;
}

const QuickQuestions: React.FC<QuickQuestionsProps> = ({
  questions,
  onSelect,
  disabled,
  visible = true,
}) => {
  const impressedKeyRef = useRef('');

  useEffect(() => {
    if (!visible) {
      impressedKeyRef.current = '';
      return;
    }
    if (!questions.length) return;
    const key = questions.map((q) => q.text).join('\0');
    if (key === impressedKeyRef.current) return;
    impressedKeyRef.current = key;
    emitGa('faq_impression', {
      question_count: questions.length,
      question_text: questions.map((q) => q.text).join(' | '),
    });
  }, [questions, visible]);

  if (!questions.length) return null;

  return (
    <div className="quick-questions">
      {questions.map((q, index) => (
        <div
          key={q.id}
          className={`quick-questions__chip${disabled ? ' quick-questions__chip--disabled' : ''}`}
          onClick={() => {
            if (disabled) return;
            emitGa('faq_click', {
              question_text: q.text,
              question_index: index,
            });
            onSelect(q.text);
          }}
        >
          <Tooltip
            title={q.text}
            overlayClassName="macaw-tooltip"
            getPopupContainer={getMacawRoot}
          >
            <span className="quick-questions__chip-text">{q.text}</span>
          </Tooltip>
          <Icon name="icon-ic_arrow_right" size={12} className="quick-questions__chip-arrow" />
        </div>
      ))}
    </div>
  );
};

export default QuickQuestions;
